// JsFromRoutes CacheKey 1b5c2a7080a74b15b1e04a05820c3128
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  impersonate: /* #__PURE__ */ definePathHelper('post', '/god-mode/users/:id/impersonate'),
}
